import React from 'react';
import { YDialog } from '../../../ui/dialog/YDialog';
import { YButton } from '../../../ui/YButton';
import { buildPlantingLogDeleteCopy } from './plantingLogUtils';

export function PlantingDeleteLogDialog({
  event,
  show = false,
  deleting = false,
  error = '',
  onHide,
  onConfirm,
}) {
  const copy = buildPlantingLogDeleteCopy(event);

  return (
    <YDialog
      show={Boolean(show && event)}
      onHide={onHide}
      title={copy.title}
      size="sm"
      testId="plant-log-delete-dialog"
      error={error}
      footer={(
        <>
          <YButton variant="secondary" type="button" onClick={onHide} disabled={deleting}>
            Keep it
          </YButton>
          <YButton
            variant="danger"
            type="button"
            data-testid="plant-log-delete-confirm"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? 'Removing…' : 'Remove from log'}
          </YButton>
        </>
      )}
    >
      <p className="plant-plans-log-missing__body" data-testid="plant-log-delete-body">
        {copy.body}
      </p>
    </YDialog>
  );
}
